import {useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult} from '@tanstack/react-query';
import {adminsApi} from '../api';
import {AdminModel, EditAdminParams} from '../model';

type AdminByIdState = {
  getAdmin: UseQueryResult<AdminModel, Error>;
  updateAdminMutation: UseMutationResult<AdminModel, Error, EditAdminParams>;
  refetchAdmin: () => void;
};

export const useAdminById = (adminId: string): AdminByIdState => {
  const queryClient = useQueryClient();
  
  const getAdmin = useQuery<AdminModel, Error>({
    queryKey: ['admin', adminId],
    queryFn: () => adminsApi.getAdminById(adminId),
    enabled: !!adminId,
  });

  const refetchAdmin = () => {
    queryClient.invalidateQueries({queryKey: ['admin', adminId]});
  }

  const updateAdminMutation = useMutation<AdminModel, Error, EditAdminParams>({
    mutationFn: ({displayName}) => adminsApi.updateAdmin({adminId, displayName}),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['admin', adminId]});
    },
  });

  return {
    getAdmin,
    updateAdminMutation,
    refetchAdmin,
  };
};
